/**
 * Color map for public land designation types.
 * Vivid, saturated values chosen to be legible on both MAP and SATELLITE basemaps.
 * Used in PublicLandLayer fill/line paint expressions and PublicLandInfoCard swatches.
 */
export const PUBLIC_LAND_COLORS: Record<string, string> = {
  'National Forest': '#009688',
  'BLM': '#B87C00',
  'State WMA': '#26C6DA',
  'State Forest': '#00BFA5',
  'State/County Park': '#00ACC1',
  'County Forest': '#4DD0E1',
  'Waterfowl Production Area': '#0097A7',
};

const FALLBACK_COLOR = '#80CBC4';

/**
 * Returns the hex color for a given public land designation string.
 * Returns the fallback (#80CBC4) for null, undefined, or unrecognized values.
 */
export function getDesignationColor(value: string | null | undefined): string {
  if (!value) return FALLBACK_COLOR;
  return PUBLIC_LAND_COLORS[value] ?? FALLBACK_COLOR;
}
